import { ClubConfigAssets } from '../../types'

import { voucherImages } from './pageImages'
import { mobileAppLogos } from './pageImages/mobile-apps'

export const assets: ClubConfigAssets = {
  voucher: voucherImages,
  mobileAppLogos,
}
